import { SidenavUtils } from '@/common/utils/SideNavUtils';
import { far, fas } from '@awesome.me/kit-b4fd369ea4/icons';

const acSideNav = {
  id: 'ac',
  displayName: 'Audit & Compliance',
  role: 'AC_VIEW',
  shortName: 'A & C',
  icon: far.faCabinetFiling,
  precedence: 999,
  route: '',
  children: [
    // Organization Menu
    SidenavUtils.orgMenu('ac'),

    // Software Section
    {
      id: 'acMenu',
      displayName: 'Software',
      role: 'AC_VIEW',
      icon: fas.faDesktop,
      precedence: 1,
      children: [
        {
          id: 'acRqmt',
          displayName: 'Requirements',
          role: 'AC_RQMT_VIEW',
          icon: fas.faInfoCircle,
          route: '/ac/rqmt',
          precedence: 2,
        },
      ],
    },

    // Testing Section
    {
      id: 'acTestMenu',
      displayName: 'Testing',
      role: 'AC_TEST_VIEW',
      icon: fas.faTachometer,
      precedence: 7,
      children: [
        {
          id: 'acSuite',
          displayName: 'Suites',
          role: 'AC_SUITE_VIEW',
          icon: fas.faTachometer,
          route: '/ac/suite',
          precedence: 8,
        },
        {
          id: 'acTest',
          displayName: 'Tests',
          role: 'AC_TEST_VIEW',
          icon: fas.faTachometer,
          route: '/ac/test',
          precedence: 9,
        },
        {
          id: 'acTestDashboard',
          displayName: 'Test Dashboard',
          role: 'AC_VIEW',
          icon: fas.faTachometer,
          route: '/ac/dashboard/test',
          precedence: 10,
        },
      ],
    },

    // Common Menus
    ...SidenavUtils.commonMenus('ac'),
  ],
};

export default acSideNav;
